"use client";

// Queue for events that are tracked before Umami loads
let eventQueue: Array<{ eventName: string; eventData?: Record<string, any> }> =
  [];
let umamiReady = false;

// Check if Umami is loaded and process queue
const checkUmamiAndProcessQueue = () => {
  const umami = window.umami;
  if (typeof window !== "undefined" && umami && !umamiReady) {
    umamiReady = true;
    // Process queued events
    eventQueue.forEach(({ eventName, eventData }) => {
      umami.track(eventName, eventData);
    });
    eventQueue = [];
  }
};

// Poll for Umami availability on page load
if (typeof window !== "undefined") {
  // Check immediately
  checkUmamiAndProcessQueue();

  // Poll every 100ms for up to 5 seconds
  let attempts = 0;
  const maxAttempts = 50;
  const pollInterval = setInterval(() => {
    attempts++;
    checkUmamiAndProcessQueue();

    if (umamiReady || attempts >= maxAttempts) {
      clearInterval(pollInterval);
    }
  }, 1000);
}

/**
 * Track an event with Umami, queueing it if Umami isn't loaded yet
 */
export const trackEvent = (
  eventName: string,
  eventData?: Record<string, any>
) => {
  if (typeof window === "undefined") return;

  if (window.umami) {
    window.umami.track(eventName, eventData);
  } else {
    // Queue the event to be sent when Umami loads
    eventQueue.push({ eventName, eventData });
  }
};

// Usage example
/*
  // Track deposit event
  try {
    window.umami?.track('tradeup', { mints: ["f8d4da9l2...", ...], fromTier: "Common", toTier: "Uncommon" });
  } catch (e) {
    // Silently ignore tracking errors
  }
*/
